// extracted by mini-css-extract-plugin
module.exports = {"signUpContainer":"LandingPageSignUp_signUpContainer__YvxPm","formContainer":"LandingPageSignUp_formContainer__iLDdr","background":"LandingPageSignUp_background__FmPQU"};